import { useRecordContext } from "ra-core";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import type { Company } from "../types";
import { customerColor } from "./customerColors";

export const CompanyAvatar = (props: {
  record?: Company;
  width?: 20 | 40;
  height?: 20 | 40;
}) => {
  const { width = 40 } = props;
  const record = useRecordContext<Company>(props);
  if (!record) return null;

  const sizeClass = width !== 40 ? "size-5" : "size-10";

  return (
    <Avatar className={sizeClass}>
      <AvatarImage
        src={record.logo?.src}
        alt={record.name}
        className="object-contain"
      />
      {/* Samme farge som forbokstav-ikonet i kundekolonnen. */}
      <AvatarFallback
        className={`text-white ${width !== 40 ? "text-xs" : "text-sm"}`}
        style={{ backgroundColor: customerColor(record.color, record.name) }}
      >
        {record.name.charAt(0).toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
};
